"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUser = void 0;
var react_query_1 = require("@tanstack/react-query");
var api_1 = require("../../api");
var useGetUser = function (_a) {
    var chain_id = _a.chain_id, phone = _a.phone;
    return (0, react_query_1.useQuery)(['send-auth-cod', chain_id], function () {
        return (0, api_1.getUser)({
            chain_id: chain_id,
            phone: phone,
        });
    });
};
exports.useGetUser = useGetUser;
